import { useMutation } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { ScoreParticipantDocument } from '../mutations/scoreParticipantDocument.mutation';
import type {
  ScoreParticipantDocumentMutation,
  ScoreParticipantDocumentMutationVariables,
} from '../types';

export const useScoreParticipantDocumentMutation = (
  options?: MutationOptions<
    ScoreParticipantDocumentMutation,
    ScoreParticipantDocumentMutationVariables
  >,
) => {
  return useMutation(gqlFetcher(ScoreParticipantDocument), options);
};
